import { routes as resourceRoutes } from './routes'

export const routes = {
  ...resourceRoutes,
} as const
